


























import { Component, Emit } from 'vue-property-decorator';
import Mixin from '@/mixin';
import VDatePicker from '@/components/items/VDatePicker.vue';
import reportViewModel from '@/views/mastercoach/reportViewModel';

@Component({
  name: 'VDateTimeDuring',
  components: { VDatePicker }
})
export default class VDateTimeDuring extends Mixin {
  public fromDate: string | null = null;
  public toDate: string | null = null;

  @Emit()
  public onSubmit() {
    if (!this.fromDate || !this.toDate) return;
    if (this.fromDate) {
      window.sessionStorage.setItem('REPORT_FROM_DATE', this.fromDate);
    }
    if (this.toDate) {
      window.sessionStorage.setItem('REPORT_TO_DATE', this.toDate);
    }
  }

  mounted() {
    if (!reportViewModel.startDate || !reportViewModel.endDate) {
      reportViewModel.loadReportParams()
    }

    this.fromDate = window.sessionStorage.getItem('REPORT_FROM_DATE') || reportViewModel.startDate;
    this.toDate = window.sessionStorage.getItem('REPORT_TO_DATE') || reportViewModel.endDate;
  }
}
